import api from '@/lib/api';

export interface AdminJob {
  id: string;
  label: string;
  description: string;
  // Overrides the confirmation dialog's default "sends notifications/emails" line
  // for jobs whose real risk is deleting data instead.
  warning?: string;
}

export const ADMIN_JOBS: AdminJob[] = [
  {
    id: 'matches/results-available',
    label: 'Resultados disponibles',
    description: 'Notifica que ya se pueden cargar los resultados de los partidos jugados.',
  },
  {
    id: 'tournament/incomplete-payment',
    label: 'Pagos incompletos',
    description: 'Avisa a las parejas que quedaron con la inscripción sin pagar del todo.',
  },
  {
    id: 'tournament/signup-deadline',
    label: 'Cierre de inscripción',
    description: 'Procesa los torneos cuyo plazo de inscripción venció.',
  },
  {
    id: 'tournament/match-start-notification',
    label: 'Aviso de inicio de partido',
    description: 'Notifica a los jugadores que su partido está por empezar.',
  },
  {
    id: 'matches/free-slots-digest',
    label: 'Resumen de turnos libres',
    description: 'Avisa a los jugadores cercanos los turnos vacíos que se crearon desde la última corrida.',
  },
  {
    id: 'matches/delete-unplayed',
    label: 'Borrar partidos no jugados',
    description: 'Limpia los partidos que quedaron sin jugarse.',
    warning: 'Se ejecuta ahora sobre datos reales y borra registros de forma permanente.',
  },
  {
    id: 'tournament/fixture-activation',
    label: 'Activación de fixture',
    description: 'Activa los fixtures que llegaron a su fecha de publicación.',
  },
  {
    id: 'lessons/start-notification',
    label: 'Aviso de inicio de clase',
    description: 'Notifica a los alumnos que su clase está por empezar.',
  },
  {
    id: 'lessons/delete-cancelled',
    label: 'Borrar clases canceladas',
    description: 'Limpia las clases que fueron canceladas.',
    warning: 'Se ejecuta ahora sobre datos reales y elimina físicamente las clases canceladas vencidas.',
  },
  {
    id: 'lessons/finish-expired',
    label: 'Finalizar clases vencidas',
    description: 'Cierra las clases cuya fecha ya pasó.',
  },
  {
    id: 'chat/close-finished-conversations',
    label: 'Cerrar chats terminados',
    description: 'Cierra las conversaciones de eventos que ya terminaron.',
  },
];

export const adminJobsApi = {
  run: async (jobId: string): Promise<void> => {
    await api.post(`/jobs/${jobId}`);
  },
};
